module.exports = __webpack_public_path__ + "static/square-foot-7b0dc0a83cc735345717c1ec0b3a2b97.jpg";